// 만료가 많이 남아도 연장 이용권 구매를 허용하는 유저 (배너 노출 21일 / 결제 버튼 25일 기준을 함께 면제)
const EXTENSION_ALWAYS_ALLOWED_USER_IDS = [107923, 101137, 96765];

// userId 는 타입은 number 지만 런타임에 string 이라 Number() 로 변환 후 비교
export function isExtensionAlwaysAllowed(userId?: number | string): boolean {
  return EXTENSION_ALWAYS_ALLOWED_USER_IDS.includes(Number(userId));
}
